import * as React from 'react';

interface IAction {
  title: string;
  action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

interface IActionButtonGroupProps {
  title: string;
  actions: IAction[];
}

export default function ActionButtonGroup(props: IActionButtonGroupProps) {
  return (
    <div
      className="btn-group mr-1 mt-1"
      role="group"
    >
      {props.actions.map((action, i) =>
        i === 0 ?
          <button
            type="button"
            className="btn btn-primary pr-1"
            onClick={action.action}
            key={i}
          >
            {props.title} {action.title}
          </button>
          :
          <button
            type="button"
            className="btn btn-info pl-1"
            onClick={action.action}
            key={i}
          >
            {action.title}
          </button>
      )}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/Calculator/ActionButtonGroup.tsx